import { render, staticRenderFns } from "./BtnDownloadXls.vue?vue&type=template&id=917efe4c&scoped=true&"
import script from "./BtnDownloadXls.vue?vue&type=script&lang=js&"
export * from "./BtnDownloadXls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917efe4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
